/*
 * Filename: /Users/jangabrielledelemos/mwell-app-web-patient/src/features/api/apiSlice.js
 * Path: /Users/jangabrielledelemos/mwell-app-web-patient
 * Created Date: Thursday, February 5th 2026, 8:48:24 am
 * Author: Jan de Lemos
 * 
 * Copyright (c) 2026 MWELL
 */

import { isRejectedWithValue } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reset } from "../auth/authSlice";

const SIGNOUT_URL = process.env.REACT_APP_SIGNOUT_URL;
const API_URL = process.env.REACT_APP_API_URL;
const SUBSCRIPTION_KEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const UNAUTHORIZED_STATUSES = [401, 403];

const prepareHeaders = (headers, { getState }) => {
  const token = getState().auth.token;

  headers.set("ocp-apim-subscription-key", SUBSCRIPTION_KEY);
  token && headers.set("authorization", `Bearer ${token}`);
  return headers;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders,
  }),
  keepUnusedDataFor: 3600, // 1 hour
  tagTypes: ["Voucher", "Appointment", "Doctor", "User"],
  endpoints: () => ({}),
});

const isLocalEnv =
  process.env.REACT_APP_ENV === "local" ||
  (typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"));

export const errorHandler = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    if (
      UNAUTHORIZED_STATUSES.includes(action.payload.status) &&
      api.getState().auth.token !== undefined
    ) {
      api.dispatch(reset());
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.removeItem("persist:root");
      }
      if (isLocalEnv) {
        window.location.replace(window.location.origin);
      } else {
        window.location.replace(SIGNOUT_URL);
      }
    } else {
      console.warn(action.payload);
    }
  }

  return next(action);
};
